<template>
  <v-container fluid>
    <div class="text-center" v-if="uploadFileProcess">
      <v-banner single-line>
        <v-progress-circular :rotate="360" :size="50" :width="15" color="cyan lighten-1" :value="value">
        </v-progress-circular>
        主题上传中
      </v-banner>
    </div>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">主题信息</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">主题列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined  color="primary" @click="openInsertDialog">
              <v-icon left>mdi-plus</v-icon>新增
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <div class="table-filter">
              <div class="box">
                <span class="label">平台类型</span>
                <v-select v-model="filterForm.parentPlatType" outlined :items="platTypeList" placeholder="请选择" solo
                  item-text="name"
                  item-value="code"
                  >
                </v-select>
              </div>
              <v-btn @click.stop="reset" class="margin-left-2x">重 置</v-btn>
              <v-btn color="primary" @click.stop="query" class="margin-left-2x">查 询</v-btn>
            </div>
            <v-data-table
              :headers="headers"
              :items="infoList"
              :items-per-page="10"
              class="elevation-1"
              :options.sync="pagination"
              :server-items-length="totalDesserts"
            >
              <template v-slot:[`item.parentPlatType`]="{ item }">
                <!-- <span>{{item.imageList}}</span> -->
                <span v-if="item.parentPlatType && platTypeList.length > 0"> {{ platTypeList.find(e => e.code === item.parentPlatType).name }} </span>
              </template>
              <template v-slot:[`item.imageList`]="{ item }">
                <!-- <span>{{item.imageList}}</span> -->
                <div style="overflow: hidden; width: 180px; cursor: pointer;" @click="openPreviewDialog(item)">
                  <v-img style="float:left;" v-for="(img, i) in item.imageList" :key="i" :src="img" cover width="60"></v-img>
                </div>
                <!-- <span v-if="item.parentPlatType && platTypeList.length > 0"> {{ platTypeList.find(e => e.code === item.parentPlatType).name }} </span> -->
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                  <!-- <v-btn class="ma-2 white--text" small  color="success" @click="openPreviewDialog(item)">查看</v-btn> -->
                  <v-btn class="ma-2 white--text" small color="blue" @click="openDeleteDialog(item)">删除</v-btn>
                  <v-btn class="ma-2 white--text" small color="warning" @click="getThemeDownloadUrl(item)">下载</v-btn>
                </template>
            </v-data-table>
          </v-card-text>
          <!-- <v-container> -->
            <!-- <v-row>
              <v-btn absolute dark fab top right color="pink" @click="openInsertDialog()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-col cols="12" sm="6" md="4" v-for="item in infoList.slice( page * 6 - 6, page * 6)" :key="item.alias">
                <v-card class="mx-auto" max-width="400" height="350">
                  <v-img class="white--text align-end" height="200px" :src="getImageUrl(item.alias, 'head')"
                    :contain="true">
                  </v-img>
                  <v-card-title>{{item.name}}</v-card-title>

                  <v-card-subtitle class="pb-0" height="20">{{item.name}} 版本号：{{item.version}} 平台类型: {{item.platType}}
                  </v-card-subtitle>

                  <v-card-text class="text--primary" height="20px" style="padding-bottom: 0">
                    <div id="infoDiv">{{item.info}}</div>
                  </v-card-text>

                  <v-card-actions height="40px">
                    <v-btn color="red" text @click="openDeleteDialog(item)">
                      删除
                    </v-btn>

                    <v-btn color="blue" text @click="openPreviewDialog(item)">
                      预览
                    </v-btn>

                    <v-btn color="blue" text :href=getThemeDownloadUrl(item)>
                      下载
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row> -->
            <!-- <div class="text-center">
              <v-pagination v-model="page" :length="totalPageLength"></v-pagination>
            </div> -->

            <v-dialog v-model="deleteDialog" max-width="400px">
              <v-card>
                <v-card-title>
                  <span class="headline">删除主题</span>
                </v-card-title>
                <v-card-text class="pb-0">
                  是否确认要删除所选的主题？<br>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="normal" @click="closeDeleteDialog" text>
                    取消
                  </v-btn>
                  <v-btn color="error" @click="deleteItem" text>
                    确定
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="insertDialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">新增主题</span>
                </v-card-title>
                <v-card-actions>
                  <v-row no-gutters style="height: 200px;">
                    <v-col cols="12">
                      <v-file-input label="主题上传(Zip格式文件)" v-model="uploadFile" accept=".zip">
                      </v-file-input>
                    </v-col>
                    <v-col cols="12">
                      <!-- | platTypeList {{platTypeList}} -->
                      <v-radio-group v-model="selectPlatType" mandatory row>
                        <v-radio v-for="(item, i) in platTypeList" :key="i"
                          :label="item.name" :value="item.code"></v-radio>
                      </v-radio-group>
                      <!-- <v-radio-group
                        v-model="selectPlatType"
                        mandatory
                        row
                      >
                        <v-radio
                          label="APP"
                          value="app"
                        ></v-radio>
                        <v-radio
                          label="PC"
                          value="pc"
                        ></v-radio>
                      </v-radio-group> -->
                    </v-col>
                    <v-col cols="12">
                      <v-btn color="normal" @click="closeInsertDialog" text>
                        取消
                      </v-btn>
                      <v-btn color="error" @click="insertItem" text>
                        确定
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="previewDialog" max-width="700px" close>
              <v-card class="mx-auto">
                <v-card-title>
                  <span class="headline">主题封面</span>
                </v-card-title>
                <!-- <v-img v-for="(imageItem, i) in this.imageItemList" :key="i" :src="imageItem" contain width="200"></v-img> -->
                <v-carousel hide-delimiters>
                  <v-carousel-item v-for="(imageItem,i) in this.imageItemList" :key="i">
                    <v-img :src="imageItem" contain height="500">
                    </v-img>
                  </v-carousel-item>

                </v-carousel>
                <v-list-item>
                  <v-list-item-content style="text-overflow:ellipsis;">
                    {{this.currentPreviewInfo}}
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-dialog>
          <!-- </v-container> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import config from '@/plugins/config'
import { mapState } from 'vuex'
import { serialize } from '@/plugins/utils'
export default {
  name: 'ThemeInfo',
  data: () => ({
    infoList: [],
    currentTheme: null,
    page: 1,
    deleteDialog: false,
    insertDialog: false,
    editedItem: null,
    uploadFile: null,
    previewDialog: false,
    imageItemList: [],
    currentPreviewInfo: '',
    selectPlatType: null,
    interval: {},
    value: 0,
    uploadFileProcess: false,
    filterForm: {
      parentPlatType: ''
    },
    headers: [
      { text: '编号', value: 'uniId' },
      { text: '名称', value: 'name' },
      { text: '平台类型', value: 'parentPlatType' },
      { text: '说明', value: 'info' },
      { text: '日期', value: 'createTime' },
      { text: '图示', value: 'imageList' },
      { text: '操作', value: 'actions' }
    ],
    pagination: { page: 1, itemsPerPage: 10 }
  }),
  watch: {
    pagination: {
      handler () {
        this.init()
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['platTypeList']),
    totalPageLength: function () {
      if (this.infoList.length % 6 === 0) {
        return this.infoList.length / 6
      } else {
        return parseInt(this.infoList.length / 6 + '') + 1
      }
    },
    platTypeListJustChildren () {
      let arr = []
      for (const val of this.platTypeList) {
        if (!val.parentCode && val.children?.length > 0) {
          arr = [...arr, ...val.children]
        } else {
          arr = [...arr, val]
        }
      }
      arr.forEach((r) => {
        r.isSelected = false
      })
      console.log('arr', arr)
      return arr
    }
  },
  created () {
    // this.init()
  },
  methods: {
    init (form) {
      if (form) {
        this.pagination.page = 1
      }
      const parmas = {
        type: 'parentPlatTypeIsNotBlank',
        page: this.pagination.page - 1,
        size: this.pagination.itemsPerPage
      }
      Object.assign(parmas, form)
      const request = buildAxios()
      request.get('theme/page?' + serialize(parmas))
        .then(res => {
          // console.log(res)
          this.infoList = res.data.data.data
          this.totalDesserts = res.data.data.totalSize
          this.infoList.forEach(element => {
            const imageList = []
            for (let i = 1; i < 4; i++) {
              const imageUrl = this.getImageUrl(element.alias, i)
              imageList.push(imageUrl)
            }
            element.imageList = imageList
          })
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        }).finally(() => {
        }
        )
    },
    getImageUrl (themeName, imageName) {
      if (themeName === undefined) {
        return ''
      }
      return config.apiBaseUrl + '/theme/getThemeImage?themeName=' + themeName + '&imageName=' + imageName + '.png'
    },
    limitInfoLength (info) {
      if (info === null) {
        return ''
      }
      if (info.length > 50) {
        return info.toString().slice(0, 50) + '...'
      }
      return info
    },
    openDeleteDialog (item) {
      this.deleteDialog = true
      this.editedItem = item
    },
    closeDeleteDialog () {
      this.deleteDialog = false
      this.editedItem = null
    },
    openInsertDialog () {
      this.insertDialog = true
    },
    closeInsertDialog () {
      this.insertDialog = false
      this.uploadFile = null
      this.selectPlatType = null
    },
    openPreviewDialog (item) {
      this.imageItemList = []
      this.previewDialog = true
      this.currentPreviewInfo = item.info
      this.getPreviewImageUrls(item)
    },
    deleteItem () {
      const request = buildAxios()
      request.get('theme/delete?themeName=' + this.editedItem.alias)
        .then(() => {
          this.$emit('alert', {
            msg: '删除成功',
            type: 'success'
          })
          const index = this.infoList.indexOf(this.editedItem)
          this.infoList.splice(index, 1)
          if (this.page > this.totalPageLength) {
            this.page = this.totalPageLength
          }
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        }).finally(() => {
          this.closeDeleteDialog()
        }
        )
    },
    insertItem () {
      this.insertDialog = false
      this.uploadFileProcess = true
      this.value = 0
      console.log('value', this.value)
      // const that = this
      this.value += 10
      const request = buildAxios({ timeOut: 300000 })
      const formData = new FormData()
      formData.append('file', this.uploadFile)
      formData.append('platType', this.selectPlatType)
      this.interval = setInterval(() => {
        if (this.value === 80) {
          clearInterval(this.interval)
          return
        }
        this.value += 10
      }, 1000)
      request.post('theme/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          this.value += 20
          this.uploadFileProcess = false
          this.$emit('alert', {
            msg: '添加成功',
            type: 'success'
          })
          const item = res.data.data
          this.infoList.push(item)
        }
        )
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        }
        ).finally(() => {
          this.insertDialog = false
          this.uploadFile = null
          this.selectPlatType = null
        }
        )
    },
    getPreviewImageUrls (item) {
      for (let i = 1; i < 4; i++) {
        const imageUrl = this.getImageUrl(item.alias, i)
        this.imageItemList.push(imageUrl)
      }
    },
    downloadTheme (item) {
      const request = buildAxios()
      request.patch('theme/download?themeName=' + item.alias)
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        }).finally(() => {
        }
        )
    },
    getThemeDownloadUrl (item) {
      return config.apiBaseUrl + '/theme/download?themeName=' + item.alias + '&local=true'
    },
    reset () {
      for (const key in this.filterForm) {
        this.filterForm[key] = ''
      }
      this.init()
    },
    query () {
      // console.log(this.filterForm)
      this.init(this.filterForm)
    }
  },
  mounted () {

  }
}
</script>

<style scoped>
#infoDiv {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
